var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParkingManagementIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1757_1271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2214 18.4557C10.2214 18.4557 16.888 13.4557 16.888 8.03906C16.888 4.5874 13.9034 1.78906 10.2214 1.78906C6.53927 1.78906 3.55469 4.5874 3.55469 8.03906C3.55469 13.4557 10.2214 18.4557 10.2214 18.4557Z",
    stroke: "#9C4900",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96875 5.95312V12.6198",
    stroke: "#9C4900",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96875 5.95312H11.4687C11.9108 5.95313 12.3347 6.12872 12.6473 6.44128C12.9598 6.75384 13.1354 7.17776 13.1354 7.61979C13.1354 8.06182 12.9598 8.48574 12.6473 8.7983C12.3347 9.11086 11.9108 9.28646 11.4687 9.28646H8.96875V5.95312Z",
    stroke: "#9C4900",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1757_1271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.21875 0.125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingManagementIcon);
export default __webpack_public_path__ + "static/media/ParkingManagement_icon.9dd3d120968311430cb71e29a6e80f9f.svg";
export { ForwardRef as ReactComponent };